<template>
  <div>
      <div style="background-color: rgb(255, 255, 255);">
        <el-row>
          <div>
            <el-form :model="listQuery" :inline="true" class="followup-filter-form" style="margin-top: 20px;margin-left: 20px">
              <el-form-item label="患者姓名">
                <el-input v-model="listQuery.patientName"></el-input>
              </el-form-item>
              <el-form-item label="登记号">
                <el-input v-model="listQuery.recordNo"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="listQuery.phone"></el-input>
              </el-form-item>
              <el-form-item label="管理标签">
                <el-select v-model="listQuery.tag">
                  <el-option v-for="x in manageTagsList" :key="x.value" :label="x.label" :value="x.value" />
                </el-select>
              </el-form-item>
              <el-form-item :label="dateFilterLabel">
                <el-date-picker v-model="valueData1" type="daterange" align="right" unlink-panels range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item v-if="showVisitStatusFilter" label="来院状态">
                <el-select v-model="listQuery.visitStatus" clearable placeholder="全部">
                  <el-option label="全部" :value="null" />
                  <el-option label="已来院" value="已来院" />
                  <el-option label="未来院" value="未来院" />
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="primary" plain @click="handleReset">重置</el-button>
                <el-button @click="handleExport">导出</el-button>
              </el-form-item>
            </el-form>
            <el-table v-loading="listLoading" :data="sortedList" border fit highlight-current-row
              style="width: 100%; margin-top: 20px;" :row-style="tableRowStyle">

              <el-table-column width="100px" align="center" label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.patientName }}</span>
                </template>
              </el-table-column>

              <el-table-column width="120px" align="center" label="登记号">
                <template slot-scope="scope">
                  <span>{{ scope.row.recordNo || '-' }}</span>
                </template>
              </el-table-column>

              <el-table-column width="80px" align="center" label="性别">
                <template slot-scope="scope">
                  <span>{{ getGender(scope.row.gender) }}</span>
                </template>
              </el-table-column>

              <el-table-column width="80px" align="center" label="年龄">
                <template slot-scope="scope">
                  <span>{{ getAge(scope.row.birthday) }}</span>
                </template>
              </el-table-column>

              <el-table-column width="130px" align="center" label="联系方式">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="管理标签" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row?.diseaseGroup || '' }}</span>
                </template>
              </el-table-column>

              <el-table-column width="140px" align="center" label="复查到期时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.reviewExpireTime ? getParsedTime(scope.row.reviewExpireTime) : '-' }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="180px" align="center" label="项目">
                <template slot-scope="scope">
                  <span>{{ scope.row.reviewItem || "-" }}</span>
                </template>
              </el-table-column>

              <el-table-column v-if="showVisitStatusFilter" width="160px" align="center" label="复查后首次来院">
                <template slot-scope="scope">
                  <span>{{ scope.row.firstVisitAfterReview ? getParsedTime(scope.row.firstVisitAfterReview) : '-' }}</span>
                </template>
              </el-table-column>

              <!-- 状态 -->
              <el-table-column v-if="followupType === '未电话通知'" width="80px" align="center" label="状态">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === '已过期'" type="danger" size="mini">已过期</el-tag>
                  <el-tag v-else type="warning" size="mini">未通知</el-tag>
                </template>
              </el-table-column>

              <!-- 已电话通知：通知时间 -->
              <el-table-column v-if="followupType === '已电话通知'" width="150px" align="center" label="通知时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.followupTime ? getParsedTime(scope.row.followupTime) : '-' }}</span>
                </template>
              </el-table-column>

              <!-- 已随访：随访时间 -->
              <el-table-column v-if="followupType === '已随访'" width="150px" align="center" label="随访时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.followupTime ? getParsedTime(scope.row.followupTime) : '-' }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" align="center" label="操作" width="260">
                <template slot-scope="scope">
                  <!-- 未电话通知：三个按钮，已通知则显示为文本 -->
                  <template v-if="followupType === '未电话通知'">
                    <template v-if="scope.row.followupFlag === '1'">
                      <span style="color: #999; margin-right: 4px;">已通知</span>
                    </template>
                    <template v-else>
                      <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                        @click="doReviewNotification(scope.row)">
                        复查通知
                      </el-button>
                    </template>
                    <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="editFollowUp(scope.row)">
                      一键随访
                    </el-button>
                    <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="patientsDetail(scope.row)">
                      健康档案
                    </el-button>
                  </template>
                  <!-- 已电话通知 / 已随访：满意度调查/调查详情 + 查看编辑随访 + 健康档案 -->
                  <template v-else-if="followupType === '已电话通知' || followupType === '已随访'">
                    <el-button v-if="scope.row.refollowFlag === '1'" style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="viewSatisfactionDetail(scope.row)">
                      调查详情
                    </el-button>
                    <el-button v-else style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="doSatisfactionSurvey(scope.row)">
                      满意度调查
                    </el-button>
                    <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="editFollowUp(scope.row)">
                      查看编辑随访
                    </el-button>
                    <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                      @click="patientsDetail(scope.row)">
                      健康档案
                    </el-button>
                  </template>
                  <!-- 失访：修改复查时间 -->
                  <el-button v-else-if="followupType === '失访'" style="margin-left: 0; padding: 0 4px;" type="text"
                    @click="editLostFollowup(scope.row)">
                    修改复查时间
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
              @pagination="turnToPage" />

            <!-- 失访：修改复查时间弹窗 -->
            <el-dialog title="修改复查时间" :visible.sync="lostFollowupDialogVisible" width="400px" @close="lostFollowupDialogVisible = false">
              <el-form :model="lostFollowupForm" label-width="120px">
                <el-form-item label="新的复查时间">
                  <el-date-picker v-model="lostFollowupForm.reviewExpireTime" type="date" placeholder="选择复查到期时间"
                    style="width:100%">
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <div slot="footer">
                <el-button @click="lostFollowupDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmLostFollowup">确认</el-button>
              </div>
            </el-dialog>

            <!-- 满意度调查弹窗 -->
            <el-dialog :title="satisfactionIsRead ? '满意度调查详情' : '满意度电话回访'" :visible.sync="satisfactionDialogVisible" width="560px"
              @close="handleSatisfactionClose">
              <el-form :model="satisfactionForm" label-width="120px">
                <el-descriptions :column="2" border style="margin-bottom: 20px;">
                  <el-descriptions-item label="患者姓名">{{ currentSatisfactionRow?.patientName || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="登记号">{{ currentSatisfactionRow?.recordNo || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="联系方式">{{ currentSatisfactionRow?.phone || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="复查项目">{{ currentSatisfactionRow?.reviewItem || '-' }}</el-descriptions-item>
                </el-descriptions>
                <el-form-item label="回访结果*">
                  <el-radio-group v-model="satisfactionForm.result" :disabled="satisfactionIsRead">
                    <el-radio label="已接听">已接听</el-radio>
                    <el-radio label="未接听">未接听</el-radio>
                    <el-radio label="拒接">拒接</el-radio>
                    <el-radio label="空号">空号</el-radio>
                    <el-radio label="停机">停机</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="满意度评分*" v-if="satisfactionForm.result === '已接听' || satisfactionIsRead">
                  <el-rate v-model="satisfactionForm.rating" :max="5" show-text allow-half :disabled="satisfactionIsRead"
                    :texts="['非常不满意', '不满意', '一般', '满意', '非常满意']">
                  </el-rate>
                </el-form-item>
                <el-form-item label="反馈意见">
                  <el-input type="textarea" v-model="satisfactionForm.feedback" :rows="3" :disabled="satisfactionIsRead"
                    placeholder="请输入患者的反馈意见"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer">
                <el-button @click="satisfactionDialogVisible = false">关闭</el-button>
                <el-button v-if="!satisfactionIsRead" type="primary" @click="confirmSatisfaction">确认提交</el-button>
              </div>
            </el-dialog>

            <lungcancerFollowupForm v-if="followupFormVisible" ref="LungcancerFollowupFormRef" @upDataList="getList"></lungcancerFollowupForm>

            <followupModal v-if="followupModalVisible" ref="FollowupModalRef" @upDataList="getList"></followupModal>

            <patientLungDetail v-if="patientDetailVisible" ref="PatientDetailRef" />
          </div>
        </el-row>
      </div>
  </div>
</template>

<script>
import {
  getListByTime,
  getPatientFollowupRecord,
  getFollowupValue,
  getUserInfos,
  delPatientFollowupRecord,
  turnToListByTime,
  getSysDicList,
  handleLostFollowup,
  refollowFollowup,
  exportLungFollowups
} from "@/api/health/Patients.js"
import { downloadExcelBlob } from "@/utils/download-excel";
import { postPatientFollowupGroupsByGroupName } from "@/api/health/Lung";
import Pagination from "@/components/Pagination";
import patientTree from '@/components/selectTree';
import patientDetail from "@/views/patient/patientDetail";
import moment from "moment";
import followupModal from "../../components/followupModal/index.vue";
import lungcancerFollowupForm from "./lungcancerFollowupForm.vue";
import patientLungDetail from "../patientLung/patientLungDetail.vue";

export default {
  components: { patientTree, Pagination, patientDetail, followupModal, lungcancerFollowupForm, patientLungDetail },
  props: {
    followupType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      followupFormVisible: false,
      followupModalVisible: false,
      patientDetailVisible: false,
      lostFollowupDialogVisible: false,
      lostFollowupForm: {
        id: null,
        reviewExpireTime: null
      },
      satisfactionDialogVisible: false,
      satisfactionForm: {
        result: null,
        rating: null,
        feedback: ''
      },
      currentSatisfactionRow: null,
      satisfactionIsRead: false,
      listLoading: false,
      list: [],
      total: 0,
      listQuery: {
        patientName: null,
        phone: null,
        tag: null,
        recordNo: null,
        startTime: null,
        endTime: null,
        visitStatus: null,
        serviceName: '肺结节随访',
        type: this.followupType || ''
      },
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      buttonVisiable: true,
      timeVisiable: true,
      valueData1: null,
      sexOptions: [],
      manageTagsList: [],
      pickerOptions: {
        shortcuts: [
          { text: "最近一周", onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit("pick", [start, end]); } },
          { text: "最近一个月", onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); picker.$emit("pick", [start, end]); } },
          { text: "最近三个月", onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); picker.$emit("pick", [start, end]); } },
        ],
      },
    };
  },
  computed: {
    sortedList() {
      return this.list;
    },
    dateFilterLabel() {
      if (this.followupType === '已电话通知') return '通知时间';
      if (this.followupType === '已随访') return '随访时间';
      return '复查到期时间';
    },
    showVisitStatusFilter() {
      return ['未电话通知', '已电话通知'].includes(this.followupType);
    },
    lightweightList() {
      return ['未电话通知', '已电话通知', '已随访'].includes(this.followupType);
    }
  },
  created() {
    this.getSystemDictList('性别');
    // 未电话通知默认与首页复查通知一致：近 7 天至今天
    if (this.followupType === '未电话通知') {
      this.valueData1 = this.defaultReviewDateRange();
    }
    this.getList();
    this.getManageTagsList();
  },
  methods: {
    defaultReviewDateRange() {
      const end = moment().startOf('day').toDate();
      const start = moment(end).subtract(7, 'days').toDate();
      return [start, end];
    },
    // 未电话通知：按复查到期时间升序排列（最早到期排最前）
    sortByReviewExpireTime(arr) {
      return arr.sort((a, b) => {
        const aTime = a.reviewExpireTime ? moment(a.reviewExpireTime).valueOf() : 0;
        const bTime = b.reviewExpireTime ? moment(b.reviewExpireTime).valueOf() : 0;
        return aTime - bTime;
      });
    },
    tableRowStyle({ row }) {
      if (this.followupType === '未电话通知') {
        return this.getPendingRowStyle(row);
      } else if (this.followupType === '已电话通知' || this.followupType === '已随访') {
        return this.getDoneRowStyle(row);
      }
      return {};
    },
    // 未电话通知行颜色
    getPendingRowStyle(row) {
      if (!row.reviewExpireTime) return {};
      const today = moment().startOf('day');
      const expireDate = moment(row.reviewExpireTime).startOf('day');
      const diffDays = expireDate.diff(today, 'days');

      if (diffDays === 0 && row.hasVisitedToday === '1') return { backgroundColor: '#fff0f0' }; // 今天且已就诊 → 淡红
      if (diffDays === 0) return { backgroundColor: '#e6f7ff' }; // 今天 → 淡蓝
      if (diffDays >= 1 && diffDays <= 7) return { backgroundColor: '#fffbe6' }; // 未来1-7天 → 淡黄
      if (diffDays < 0) return { backgroundColor: '#fffbe6' }; // 已过期 → 淡黄
      return {};
    },
    // 已电话通知 / 已随访行颜色
    getDoneRowStyle(row) {
      // refollowFlag = '1' → 已做过满意度回访 → 白色
      if (row.refollowFlag === '1') return {};
      // refollowFlag IS NULL → 需要满意度调查 → 淡黄
      return { backgroundColor: '#fffbe6' };
    },
    getSystemDictList(typeName) {
      getSysDicList({ typeName }).then(res => {
        if (res.msg == "success") this.sexOptions = res.data.records;
      }).catch(err => console.log(err));
    },
    async getManageTagsList() {
      postPatientFollowupGroupsByGroupName({}).then(res => {
        if (res.msg === 'success') {
          this.manageTagsList = [{ label: "全部", value: null }, ...(res.data?.records?.map(x => ({
            label: x.groupName, value: x.groupName
          })) || [])];
        }
      }).catch(err => console.log(err));
    },
    getList() {
      this.list = [];
      this.listLoading = true;
      if (this.valueData1 && this.timeVisiable) {
        this.listQuery.startTime = this.getParseDate(this.valueData1[0], 1);
        this.listQuery.endTime = this.getParseDate(this.valueData1[1], 2);
      } else if (!this.valueData1 && this.timeVisiable) {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }

      const params = Object.assign({}, this.listQuery, {
        includeExtraInfo: !this.lightweightList
      });
      getListByTime(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.total = res.data.total;
          this.list = res.data.records;
        }
      }).catch(error => {
        console.log(error);
        this.listLoading = false;
      });
    },
    async handleExport() {
      if (this.valueData1 && this.timeVisiable) {
        this.listQuery.startTime = this.getParseDate(this.valueData1[0], 1);
        this.listQuery.endTime = this.getParseDate(this.valueData1[1], 2);
      } else if (!this.valueData1 && this.timeVisiable) {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }
      try {
        const params = Object.assign({}, this.listQuery, { includeExtraInfo: true });
        const data = await exportLungFollowups(params);
        downloadExcelBlob(data, `肺结节${this.followupType || '随访'}_${moment().format('YYYYMMDDHHmm')}.xlsx`);
      } catch (error) {
        console.error(error);
        this.$message.error("导出失败");
      }
    },
    handleReset() {
      this.listQuery.patientName = null;
      this.listQuery.phone = null;
      this.listQuery.tag = null;
      this.listQuery.recordNo = null;
      this.listQuery.startTime = null;
      this.listQuery.endTime = null;
      this.listQuery.visitStatus = null;
      if (this.followupType) this.listQuery.type = this.followupType;
      this.valueData1 = this.followupType === '未电话通知'
        ? this.defaultReviewDateRange()
        : null;
      this.getList();
    },
    turnToPage() {
      const params = Object.assign({}, this.listQuery, this.formData, {
        includeExtraInfo: !this.lightweightList
      });
      this.listLoading = true;
      turnToListByTime(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    doReviewNotification(row) {
      // 复查通知：使用原来的电话接听表单
      this.onEdit(row, false, 'reviewNotification');
    },
    editFollowUp(row) {
      this.followupFormVisible = true;
      this.$nextTick(() => {
        this.$refs.LungcancerFollowupFormRef.init(row);
      });
    },
    doSatisfactionSurvey(row) {
      this.currentSatisfactionRow = row;
      this.satisfactionIsRead = false;
      this.satisfactionForm = { result: null, rating: null, feedback: '' };
      this.satisfactionDialogVisible = true;
    },
    viewSatisfactionDetail(row) {
      this.currentSatisfactionRow = row;
      this.satisfactionIsRead = true;
      this.satisfactionForm = {
        result: row.refollowPhone || null,
        rating: row.refollowObey ? Number(row.refollowObey) : null,
        feedback: row.refollowSubjective || ''
      };
      this.satisfactionDialogVisible = true;
    },
    confirmSatisfaction() {
      if (!this.satisfactionForm.result) {
        this.$message.error('请选择回访结果');
        return;
      }
      if (this.satisfactionForm.result === '已接听' && !this.satisfactionForm.rating) {
        this.$message.error('请选择满意度评分');
        return;
      }
      const params = {
        id: this.currentSatisfactionRow.id,
        refollowFlag: '1',
        refollowPhone: this.satisfactionForm.result,
        refollowObey: this.satisfactionForm.rating ? String(this.satisfactionForm.rating) : null,
        refollowSubjective: this.satisfactionForm.feedback || null
      };
      refollowFollowup(params).then(res => {
        if (res.msg === 'success') {
          this.$message.success('满意度电话回访提交成功');
          this.satisfactionDialogVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('提交失败');
      });
    },
    handleSatisfactionClose() {
      this.satisfactionDialogVisible = false;
    },
    editLostFollowup(row) {
      this.lostFollowupForm.id = row.id;
      this.lostFollowupForm.reviewExpireTime = null;
      this.lostFollowupDialogVisible = true;
    },
    confirmLostFollowup() {
      if (!this.lostFollowupForm.reviewExpireTime) {
        this.$message.error('请选择新的复查时间');
        return;
      }
      handleLostFollowup(this.lostFollowupForm).then(res => {
        if (res.msg === 'success') {
          this.$message.success('失访处理成功，已重新安排随访');
          this.lostFollowupDialogVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('操作失败');
      });
    },
    patientsDetail(row) {
      this.patientDetailVisible = true;
      this.$nextTick(() => this.$refs["PatientDetailRef"].init(row));
    },
    onEdit(row, isRead, mode = 'oneClickFollowup') {
      // 原有一键随访/复查通知：打开电话接听表单
      row.pInfo = this.pInfo;
      row.isRead = isRead;
      const params = { idcard: row.idcard, paramNames: ['空腹血糖'] };
      const data = { idcard: row.idcard, status: "已完成" };

      if (row.status == "已完成") {
        getPatientFollowupRecord(row.id).then((res) => {
          if (res.msg == "success") {
            row.records = res.data;
            getFollowupValue(params).then((response) => {
              if (response.msg == "success" && response.data.length > 0) {
                const resData = response.data[0];
                row.bloodSuger = resData.paramValue;
                row.nextFollowupTime = resData.nextFollowupTime;
                row.bloodsugarTime = resData.checkTime;
              }
              this.followupModalVisible = true;
              this.$nextTick(() => this.$refs.FollowupModalRef.init(row, mode));
            });
          }
        }).catch(err => console.log(err));
      } else {
        getListByTime(data).then((res) => {
          if (res.msg == "success") {
            row.records = res.data.records[0];
            getFollowupValue(params).then((response) => {
              if (response.msg == "success" && response.data.length > 0) {
                const resData = response.data[0];
                row.bloodSuger = resData.paramValue;
                row.nextFollowupTime = resData.nextFollowupTime;
                row.bloodsugarTime = resData.checkTime;
              }
              this.followupModalVisible = true;
              this.$nextTick(() => this.$refs.FollowupModalRef.init(row, mode));
            });
          }
        });
      }
    },
    onDelete(row) {
      this.$confirm("此操作将删除该随访信息, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        this.listLoading = true;
        delPatientFollowupRecord({ id: row.id }).then((res) => {
          this.listLoading = false;
          this.$message({ message: res.msg == "success" ? "删除成功！" : "删除失败！", type: res.msg == "success" ? "success" : "error" });
          if (res.msg == "success") this.getList();
        });
      }).catch(() => this.$message({ type: "info", message: "已取消删除" }));
    },
    getGender(gender) {
      const option = this.sexOptions.filter(v => v.value == gender)[0];
      return option?.name;
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    getAge(birthday) {
      if (!birthday) return "";
      const birthdays = new Date(birthday.replace(/-/g, "/"));
      const d = new Date();
      return d.getFullYear() - birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() && d.getDate() < birthdays.getDate()) ? 1 : 0);
    },
    getParseDate(time, type) {
      const newTime = type == 2 ? new Date((new Date(time) / 1000 + 86400) * 1000) : new Date(time);
      const year = newTime.getFullYear();
      const month = newTime.getMonth() + 1;
      const date = newTime.getDate();
      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
  }
};
</script>

<style lang="scss" scoped>
.demo-table-expand { font-size: 0; }
.demo-table-expand label { width: 10px; color: #99a9bf; }
.demo-table-expand .el-form-item { margin-right: 0; margin-bottom: 0; }
.followup-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 10px;
}
.followup-filter-form ::v-deep .el-form-item {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-right: 12px;
  margin-bottom: 0;
}
.form ::v-deep {
  .el-form-item { display: inline-flex; }
  .el-input--medium .el-input__inner { width: 209px !important; }
  .el-form-item__content { margin-left: 10px !important; }
}
</style>
